export default {
  header: ({ props, instance }) => ({
    class: [
      'text-xs',

      // Flex
      'flex items-center justify-between',

      // Colors
      'text-surface-700',
      { 'bg-brand-greyscale-neutral-50 cursor-not-allowed': instance.$attrs['variation'] },
      { 'bg-white cursor-pointer': !instance.$attrs['variation'] },

      // Conditional Spacing
      {
        'pt-4 px-4': !props.toggleable && !instance.$attrs['google-address'],
        'py-3 px-5': props.toggleable && !instance.$attrs['google-address'],
      },
    ],
  }),
  title: {
    class: 'leading-none font-bold',
  },
  toggler: {
    class: [
      // Alignments
      'inline-flex items-center justify-center',
      'relative',

      // Sized
      'w-8 h-8',
      'm-0 p-0',

      //Shape
      'border-0 rounded-full',

      //Color
      'bg-transparent',
      'text-surface-600',

      // States
      'hover:text-surface-800',
      'hover:bg-surface-100',
      'focus:outline-none focus:outline-offset-0 focus-visible:ring focus-visible:ring-primary-400/50 focus-visible:ring-inset',

      // Transitions
      'transition-all duration-200 ease-in-out',

      // Misc
      'overflow-hidden no-underline',
      'cursor-pointer',
    ],
  },
  togglerIcon: {
    class: 'inline-block',
  },
  content: ({ instance }) => ({
    class: [
      'text-xs',

      // Spacing
      { 'pt-0.5 px-4': !instance.$attrs['google-address'] },

      //Color
      'text-surface-700',
      { 'bg-brand-greyscale-neutral-50 cursor-not-allowed': instance.$attrs['variation'] },
      { 'bg-white cursor-pointer': !instance.$attrs['variation'] },
    ],
  }),
  footer: {
    class: [
      // Spacing
      'p-0',

      // Shape
      'rounded-br-lg rounded-bl-lg',

      //Color
      'bg-surface-0',
      'text-surface-700',
    ],
  },
  transition: {
    enterFromClass: 'max-h-0',
    enterActiveClass:
      'overflow-hidden transition-[max-height] duration-1000 ease-[cubic-bezier(0.42,0,0.58,1)]',
    enterToClass: 'max-h-[1000px]',
    leaveFromClass: 'max-h-[1000px]',
    leaveActiveClass:
      'overflow-hidden transition-[max-height] duration-450 ease-[cubic-bezier(0,1,0,1)]',
    leaveToClass: 'max-h-0',
  },
};
